module.exports = __webpack_public_path__ + "static/social-display-ads-plant-1-7d04e8f5e3fa948e154c175b511584ef.svg";